import { render, staticRenderFns } from "./CCFooter.vue?vue&type=template&id=e302e542&scoped=true"
import script from "./CCFooter.vue?vue&type=script&lang=js"
export * from "./CCFooter.vue?vue&type=script&lang=js"
import style0 from "./CCFooter.vue?vue&type=style&index=0&id=e302e542&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e302e542",
  null
  
)

export default component.exports